import React, { useState } from "react"
import Button from "../../../shared/components/atoms/button/button"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"

import "./step6-register.scss"
import emailReguex from "../../../shared/utils/emailRegex"
import { registerStepDatalayer } from "../../../utils/registerDatalayer"

const Step6Register = props => {
  //name parent for country
  const nameParent = () => {
    switch (process.env.LOCALE) {
      case "es-EC":
        return "representante"
      case "es-PE":
        return "apoderado"
      case "es-PR":
        return "encargado"
      case "es-AR":
      case "es-UY":
      case "es-PY":
        return "tutor legal"
      case "es-DO":
        return "tutor"
      case "es-BO":
        return "tutor"
      case "es-CL":
        return "apoderado"
      default:
        return "acudiente"
    }
  }

  const [isModalWarning, setIsModalWarning] = useState(false)
  const [confirmEmailError, setConfirmEmailError] = useState()

  const isValidEmailConfirmation = () => {
    if (props.values.parentEmail === props.getValues("parentEmailConfirmation"))
      return true
    setConfirmEmailError("Los correos no coinciden.")
    return false
  }

  const isValidNumberConfirmation = () => {
    if (props.values.parentCellPhone) return true
    return false
  }

  const onSubmitModal = data => {
    // props.onSubmit("register")

    if (
      (data.parentEmail !== "" || data.parentCellPhone !== "") &&
      data.parentName !== ""
    ) {
      setIsModalWarning(true)
    }
  }

  return (
    <>
      <form
        name="pre-register"
        onSubmit={props.handleSubmit(data => {
          if (isValidEmailConfirmation() || isValidNumberConfirmation()){
            onSubmitModal(data)
            registerStepDatalayer({ category: "registro_6", label: "finalizar" })
          }
        })}
      >
        <div className="f-step-register-form">
          <p className="f-step-register-copy">
            Como {process.env.LOCALE === "es-PY" ? "sos" : "aún eres"} menor de
            edad debemos{" "}
            {process.env.LOCALE === "es-PY" ? "solicitar" : "solicitarle"}{" "}
            <span className="color-pink">
              a tus padres o a tu {nameParent()} que autorice tu registro,{" "}
            </span>
            {process.env.LOCALE === "es-PY" ? "dejanos" : "déjanos"} sus datos
            para ponernos en contacto con ellos.
          </p>
          <span className="f-step-register-form-error-generic">
            {Object.keys(props.errors).length > 0 &&
              "*Debes completar todos los campos"}
          </span>
          {props.existDataParent && (
            <span className="f-step-register-form-error-generic">
              *Los datos de contacto de tu {nameParent()} no pueden ser iguales
              a los tuyos.
            </span>
          )}
          <div className="f-step-register-form-item">
            <div>
              <label>NOMBRE DE TU {nameParent().toUpperCase()}</label>
              <input
                type="text"
                name="parentName"
                maxLength="60"
                className={
                  props.errors.parentName
                    ? "f-form-parentName f-error-value"
                    : "f-form-parentName"
                }
                autoComplete="off"
                id={"outlined-parentName"}
                onBlur={props.handleChange}
                ref={props.register({
                  required: true,
                  pattern: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                })}
              />
              <span className="f-step-register-form-error f-step-register-form-error-label">
                {props.errors.parentName &&
                props.errors.parentName.type === "required"
                  ? ""
                  : props.errors.parentName && "Nombre inválido"}
              </span>
            </div>
          </div>
          <div className="f-step-register-form-item ">
            <div>
              <label>LO CONTACTAMOS POR:</label>
              <div className="f-step-register-form-item ">
                <div className="f-step-register-form-radio radio-parent">
                  Celular (SMS)
                  <input
                    defaultChecked
                    type="radio"
                    name="parentCodeDestination"
                    onChange={props.handleChange}
                    value="SMS"
                    ref={props.register}
                  />
                  <span className="checkmark"></span>
                </div>
                <div className="f-step-register-form-radio radio-parent">
                  Correo
                  <input
                    type="radio"
                    name="parentCodeDestination"
                    onChange={props.handleChange}
                    value="EMAIL"
                    ref={props.register}
                  />
                  <span className="checkmark"></span>
                </div>
              </div>
            </div>
          </div>
          <div className="f-step-register-form-item "></div>
        </div>
        <div className="f-step-register-form">
          <div className="f-step-register-form-item">
            {props.values.parentCodeDestination === "EMAIL" && (
              <div className="f-form-animation">
                <div className="row f-container-information-parent">
                  <div className="column">
                    <label>CORREO DE TU {nameParent().toUpperCase()}</label>
                    <br />
                    <input
                      type="email"
                      name="parentEmail"
                      maxLength="60"
                      className={
                        props.errors.parentEmail || confirmEmailError
                          ? "f-form-parentEmail f-error-value"
                          : "f-form-parentEmail"
                      }
                      autoComplete="off"
                      id={"outlined-parentEmail"}
                      onBlur={props.handleChange}
                      ref={props.register({
                        required: true,
                        pattern: emailReguex(),
                      })}
                      onChange={() => {
                        setConfirmEmailError()
                      }}
                    />
                  </div>
                  <div className="column second">
                    <label>
                      CONFIRMA EL CORREO DE TU {nameParent().toUpperCase()}
                    </label>
                    <input
                      type="email"
                      name="parentEmailConfirmation"
                      maxLength="60"
                      className={
                        confirmEmailError
                          ? "f-form-parentEmail f-error-value"
                          : "f-form-parentEmail"
                      }
                      autoComplete="off"
                      id={"outlined-parentEmail"}
                      onBlur={() => {
                        isValidEmailConfirmation()
                      }}
                      onChange={() => {
                        setConfirmEmailError()
                      }}
                      onPaste={e => {
                        e.preventDefault()
                      }}
                      ref={props.register({
                        required: true,
                        pattern: emailReguex(),
                      })}
                    />
                  </div>
                </div>
                <span className="f-step-register-form-error f-step-register-form-error-label">
                  {props.errors.parentEmail &&
                  props.errors.parentEmail.type === "required"
                    ? ""
                    : props.errors.parentEmail &&
                      props.errors.parentEmail.type === "DEM010" &&
                      props.errors.parentEmail.message}
                  {confirmEmailError ? ` ${confirmEmailError}` : ""}
                </span>
              </div>
            )}
            {props.values.parentCodeDestination === "SMS" && (
              <div className="f-form-animation">
                <label>CELULAR DE TU {nameParent().toUpperCase()}</label>
                <input
                  type="number"
                  name="parentCellPhone"
                  maxLength="60"
                  className={
                    props.errors.parentCellPhone
                      ? "f-form-parentCellPhone f-error-value"
                      : "f-form-parentCellPhone"
                  }
                  autoComplete="off"
                  id={"outlined-parentCellPhone"}
                  onBlur={props.handleChange}
                  pattern="\d*"
                  ref={props.register({
                    required: true,
                    maxLength: parseInt(process.env.MAX_DIGITS),
                    minLength: parseInt(process.env.MIN_DIGITS),
                    min: 0,
                  })}
                />
                <span className="f-step-register-form-error f-step-register-form-error-label">
                  {props.errors.parentCellPhone &&
                  props.errors.parentCellPhone.type === "required"
                    ? ""
                    : props.errors.parentCellPhone && "CELULAR inválido"}
                </span>
              </div>
            )}
          </div>
        </div>
        <div
          className={
            !props.loadServer
              ? "f-step-register-buttons"
              : "f-step-register-buttons f-step-register-buttons-disable"
          }
        >
          <Button
            className="new-primary-pink  short f-btn-form-nextStep"
            title="Finalizar"
            type="submit"
          />
          <div
            className="f-step-register-buttons-back"
            onClick={e => {
              registerStepDatalayer({ category: "registro_6", label: "anterior" })
              props.hadleBack && props.hadleBack(e)
            }}
          >
            <Button
              className="new-primary-pink--outline short f-btn-form-prevStep"
              title="Anterior"
            />
          </div>
        </div>
      </form>

      {isModalWarning && (
        <GenericModal>
          <div className="f-modal-info f-warning-modal">
            <div className="f-main-title-container">
              <label className="f-main-title">
                ¿Ingresaste bien los datos de tu {nameParent()}?
              </label>
            </div>
            <div className="f-modal-info-data">
              <p className="f-modal-info-data__title">Nombre {nameParent()}</p>
              <p className="f-modal-info-data__value">
                {props.values.parentName}
              </p>
              <p className="f-modal-info-data__title">
                {props.values.parentCodeDestination === "EMAIL" && "Correo"}
                {props.values.parentCodeDestination === "SMS" && "Contacto"}
              </p>
              <p className="f-modal-info-data__value">
                {props.values.parentCodeDestination === "EMAIL" &&
                  props.values.parentEmail}

                {props.values.parentCodeDestination === "SMS" &&
                  props.values.parentCellPhone}
              </p>
            </div>
            <div className="f-description-container">
              <p className="f-description">
                Asegurate de que estén correctos, sin su aprobación no podrás
                continuar con el proceso de registro
              </p>
            </div>

            <div className="f-btn-interaction-container f-warning-modal-buttons">
              <Button
                title="Modificar"
                className="new-primary-pink--outline"
                onClick={() => {
                  registerStepDatalayer({ category: "confirmar_datos", label: "modificar" })
                  setIsModalWarning(false)
                }}
              />

              <Button
                title="Finalizar"
                className="new-primary-pink"
                onClick={() => {
                  setIsModalWarning(false)
                  registerStepDatalayer({ category: "confirmar_datos", label: "finalizar" })
                  props.onSubmit("register")
                }}
              />
              {/* </a> */}
            </div>
          </div>
        </GenericModal>
      )}
    </>
  )
}

export default Step6Register
